import { titleCase } from '../lib/format';

/** One place decides how a lifecycle state looks, so the colours never drift. */
export function StatusPill({ status }: { status: string }) {
  return <span className={`pill pill--${status.toLowerCase()}`}>{titleCase(status)}</span>;
}
